import SelectedPlanTerms from './SelectedPlanTerms';

export default SelectedPlanTerms;
